import { MutationCache, QueryClient } from "@tanstack/react-query";
import { HttpStatusCode, isAxiosError } from "axios";
import { ZodError } from "zod";

import { captureException } from "@/utils/error-reporting";

const TERMINAL_STATUS_CODES: number[] = [
  HttpStatusCode.Unauthorized,
  HttpStatusCode.Forbidden,
  HttpStatusCode.NotFound,
];

const isTerminalError = (error: unknown) => {
  return (
    error instanceof ZodError ||
    (isAxiosError(error) &&
      !!error.response &&
      TERMINAL_STATUS_CODES.includes(error.response.status))
  );
};

export const retryRecoverableError = (failureCount: number, error: unknown) => {
  return isTerminalError(error) ? false : failureCount <= 3;
};

export const retryRecoverableErrorOnce = (failureCount: number, error: unknown) => {
  return retryRecoverableError(failureCount, error) && failureCount < 1;
};

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error) => {
      captureException(error);
    },
  }),
  defaultOptions: {
    queries: {
      throwOnError: (error) => {
        captureException(error);

        return false;
      },
      retry: retryRecoverableError,
    },
  },
});
